import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  darker?: boolean;
}
export function Section({
  children,
  className = '',
  darker = false
}: SectionProps) {
  return <section className={`py-16 md:py-24 ${darker ? 'bg-brand-darker' : 'bg-brand-dark'} border-b border-brand-gray/30 ${className}`} data-id="element-160">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-162">
          {children}
        </motion.div>
      </div>
    </section>;
}